import toast from 'react-hot-toast';
import { adminServices } from '../services/admin.service';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useDeleteAdmin = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: adminServices.deleteAdmin,
    onSuccess: () => {
      queryClient.invalidateQueries(['admins']);
      toast.success('Admin update successfully');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to delete admin');
    },
  });
};
